import React, { Fragment } from 'react'
import {
  HTMLBody,
  HTMLInnerContainer,
  HTMLMainContainer,
  HTMLOuterContainer,
} from './style/HTML.css'

export default function HTML({ data, isPage }) {
  const mainContainerCondition = isPage.priceGuarantee ||
    isPage.returnsCenter ||
    isPage.lifetimeReplacement
  const specificPagesCondition = isPage.priceGuarantee || isPage.returnsCenter ||
    isPage.lifetimeReplacement || isPage.returnPolicy
  return (
    <>
      <HTMLMainContainer containerCondition={mainContainerCondition}>
        <HTMLOuterContainer returnsCenter={isPage.returnsCenter}>
          <HTMLInnerContainer isSpecificPages={specificPagesCondition}>
            <HTMLBody
              size="small"
              color="dark-2"
              dangerouslySetInnerHTML={{
                __html: data,
              }}
            />
          </HTMLInnerContainer>
        </HTMLOuterContainer>
      </HTMLMainContainer>
    </>
  )
}
